import { render, staticRenderFns } from "./ProfileRow.vue?vue&type=template&id=ed28576a"
import script from "./ProfileRow.vue?vue&type=script&lang=ts"
export * from "./ProfileRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed28576a')) {
      api.createRecord('ed28576a', component.options)
    } else {
      api.reload('ed28576a', component.options)
    }
    module.hot.accept("./ProfileRow.vue?vue&type=template&id=ed28576a", function () {
      api.rerender('ed28576a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/comparison/ProfileRow.vue"
export default component.exports